











































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
const { VUE_APP_FCAPI: FCAPI } = process.env;
import { AxiosResponse } from 'axios';
const uuidv4 = require('uuid/v4');
const dateFormat = require('bmh/date-format');
const API = {
  record: `${FCAPI}/shang/weixin/open/record`,
  category: `${FCAPI}/shang/weixin/open/category`, // 获取授权小程序帐号已设置的类目
  tester: `${FCAPI}/shang/weixin/open/tester`, // 体验者
};

@Component
export default class Release extends Vue {
  isLoading: boolean = false;
  isShowExperience: boolean = false;
  isShowOfficial: boolean = false;
  isShowAudit: boolean = false;
  isShowCreateTest: boolean = false;
  isPublishedOnline: boolean = false;
  isExperienceError: boolean = false;
  isAuthorizeApp: boolean = true;
  isRevocation: boolean = false;
  isRollBack: boolean = false;
  formItemLayout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  online: any = {}; // 正式版
  audit: any = {}; // 审核版
  testing: any = {}; // 体验版
  category_list: any = [];
  optionsItem: any = [];
  serve: any = [];
  serveArr: any = [];
  tag: any = '';
  template_id: any = ''; // 提交审核、重新提交审核需要传不同的id

  async query() {
    this.isLoading = true;
    const res: AxiosResponse = await this.$axios.get(API.record);
    const remote = res.data;
    if (remote.status === 401) {
      this.isAuthorizeApp = false;
      this.isLoading = false;
      return;
    }

    if (remote.status !== 200) {
      console.debug(remote.message);
      this.isLoading = false;
      return;
    }

    this.isShowCreateTest = remote.data.enable_to_create_new_test;
    const record = remote.data.record;
    this.online = record.online || {};
    this.online.create_time = this.online.create_time
      ? dateFormat(this.online.create_time * 1000, '%Y-%m-%d %H:%M:%S')
      : undefined;
    this.audit = record.audit || {};
    this.audit.create_time = this.audit.create_time
      ? dateFormat(this.audit.create_time * 1000, '%Y-%m-%d %H:%M:%S')
      : undefined;
    this.testing = record.testing || {};
    this.testing.create_time = this.testing.create_time
      ? dateFormat(this.testing.create_time * 1000, '%Y-%m-%d %H:%M:%S')
      : undefined;

    this.isLoading = false;
  }

  async getCateGory() {
    const res: AxiosResponse = await this.$axios.get(API.category);
    const remote = res.data;
    if (remote.status !== 200) {
      console.debug(remote.message);
      return;
    }

    function handler(obj: any, item: any, layer: number): any {
      const map: any = {
        0: 'first',
        1: 'second',
        2: 'third',
      };
      const key = item[`${map[layer]}_id`];
      if (!obj[key]) {
        obj[key] = {
          value: key,
          label: item[`${map[layer]}_class`],
        };
      }
      if (item[`${map[layer + 1]}_id`]) {
        obj[key].children = handler(obj[key].children || {}, item, layer + 1);
      }
      return obj;
    }
    let category_obj: any = {};
    remote.data.forEach((item: any) => {
      category_obj = handler(category_obj, item, 0);
    });

    function coverter(obj: any): any {
      const list = [];
      for (const key of Object.keys(obj)) {
        const value: any = obj[key];
        if (value.children) {
          value.children = coverter(value.children);
        }
        list.push(value);
      }
      return list;
    }

    this.category_list = coverter(category_obj);
    this.serve = [
      this.category_list[0].value,
      this.category_list[0].children[0].value,
      this.category_list[0].children[0].children
        ? this.category_list[0].children[0].children[0].value
        : undefined,
    ]; // 类目默认选择第一条
    this.serveArr = [this.category_list[0], this.category_list[0].children[0]];
  }

  onChange(value: any, selectedOptions: any) {
    this.serve = value;
    this.serveArr = selectedOptions;
  }

  showAuditModel(template_id: any) {
    this.template_id = template_id;
    this.isShowAudit = true;
  }

  async submitAudit() {
    // 提交审核
    const sendData: any = {};
    sendData.tag = this.tag;
    sendData.first_class = this.serveArr[0].label;
    sendData.second_class = this.serveArr[1].label;
    sendData.first_id = this.serve[0];
    sendData.second_id = this.serve[1];
    if (this.serve[2]) {
      sendData.third_class = this.serveArr[2].label;
      sendData.third_id = this.serve[2];
    }
    sendData.title = '首页';

    const res: AxiosResponse = await this.$axios.put(
      API.record + '/' + this.template_id,
      {
        status: 'AUDIT_PENDING',
        item_list: [sendData],
      }
    );

    const remote = res.data;
    if (remote.status !== 200) {
      console.debug(remote.message);
      this.isShowAudit = false;
      return;
    }
    this.$message.success('提交成功');
    await this.query();
    this.isShowAudit = false;
  }

  async getExperience() {
    if (this.isAuthorizeApp) {
      await this.submitExperience();
    } else {
      this.isExperienceError = true;
    }
  }

  goToAuthorize() {
    this.$router.push('/setting/authorize');
  }

  async revocation() {
    // 撤回审核
    const res: AxiosResponse = await this.$axios.put(
      API.record + '/' + this.audit.template_id,
      {
        status: 'AUDIT_RECALL',
      }
    );

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('撤回成功');
    await this.query();

    this.isRevocation = false;
  }

  async submitExperience() {
    // 提交体验版
    const res: AxiosResponse = await this.$axios.post(API.record);
    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('更新成功');
    await this.query();
  }

  async releaseOnline() {
    // 撤回审核
    const res: AxiosResponse = await this.$axios.put(
      API.record + '/' + this.audit.template_id,
      {
        status: 'ONLINE',
      }
    );

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('发布成功');
    await this.query();
    this.isPublishedOnline = false;
  }

  async rollBack() {
    // 版本回退

    const res: AxiosResponse = await this.$axios.put(
      API.record + '/' + this.online.template_id,
      {
        status: 'ROLLBACK',
      }
    );

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('回滚成功');
    await this.query();
    this.isRollBack = false;
  }

  getPopupContainer() {
    return document.getElementById('release');
  }

  async created() {
    await this.query();
    await this.getCateGory();
  }
}
